/**
 * Fatiado de lib/api.ts por domínio (#131, regra R3).
 */
import { get, post } from './client.js'
// ─── i18n — catálogo de idiomas e textos de UI (tabelas locales / ui_texts) ──

export type LocaleMetaDto = {
  code: string
  label: string
  native: string
  base: string
  currency: string
  rtl: boolean
}

export type I18nRefreshResult = {
  started: boolean
  /** rascunhos de IA descartados para re-tradução */
  invalidated: number
}

/** Execução de tradução de um idioma — status visível do pipeline. */
export type I18nRun = {
  id: string
  tenant_id: string // '' = plataforma (dicionário da base)
  scope: 'menu' | 'ui_base'
  locale: string
  status: 'running' | 'done' | 'partial' | 'error'
  total_items: number
  translated_items: number
  error: string | null
  started_at: number
  finished_at: number | null
}

export type I18nRunWithTenant = I18nRun & { tenant_name: string | null }

export type I18nRunLog = {
  id: string
  run_id: string
  level: 'info' | 'warn' | 'error'
  message: string
  created_at: number
}

export type AdminDictionary = {
  locale: string
  base: string
  rtl: boolean
  values: Record<string, string>
}

export const i18n = {
  /** Catálogo de idiomas ativos — fonte: tabela `locales` no banco. */
  locales: () => get<LocaleMetaDto[]>('/admin/i18n/locales'),
  /** Dicionário da tela de LOGIN (público — só chaves admin.login.*). */
  loginDictionary: (locale: string) =>
    get<AdminDictionary>(`/admin/i18n/login-dictionary?locale=${encodeURIComponent(locale)}`),
  /** Botão "Atualizar traduções": re-traduz o cardápio deste restaurante. */
  refresh: () => post<I18nRefreshResult>('/admin/i18n/refresh', {}),
  /** Execuções deste restaurante (status ao vivo, polling). */
  runs: () => get<I18nRun[]>('/admin/i18n/runs'),
  /** Eventos de uma execução. */
  runLogs: (runId: string) => get<I18nRunLog[]>(`/admin/i18n/runs/${runId}/logs`),
  /** Dicionário da UI do painel (chaves admin.*) com fallback resolvido. */
  dictionary: (locale: string) =>
    get<AdminDictionary>(`/admin/i18n/dictionary?locale=${encodeURIComponent(locale)}`),
}
